import sharing from "./../templates/sharing.dust";

import language from "./../dictionary";

import { generateSecurePreviewURL } from "./../utilities/utils";

import {
  CLICKED_FACEBOOK_SHARE,
  CLICKED_MAIL_SHARE,
  CLICKED_TWITTER_X_SHARE,
  CLICKED_PRINT_ALB,
  CLICKED_PRINT_TEXT_ALB,
  CLICKED_PRINT_IMAGE_ALB,
  CLICKED_WHATSAPP_SHARE,
} from "./../analytics/analyticsevents";
import { hideLoaderAndChangeLocation } from "../utilities/location";
import { fetchBlob } from "../utilities/fileDownloader";

export default class SharingComponent {
  appState;
  sharingUrls;
  options;
  DOMContainer;
  body;
  constructor(appState, sharingUrls, DOMContainer, options = {}, eventName) {
    this.appState = appState;
    this.sharingUrls = sharingUrls;
    this.options = options;
    this.DOMContainer = DOMContainer;
    this.sharingEventName = eventName;
    this.body = document.body;
    this.render();
  }

  close(e, force) {
    if (this.rendered) {
      const print = this.DOMContainer.querySelector(".sharing-item.print");
      if (
        force ||
        !print ||
        (print !== e.target && !$.contains(print, e.target))
      ) {
        this.DOMContainer.classList.add("hidden");
        return true;
      }
    }
    return false;
  }

  render() {
    if (this.DOMContainer) {
      const context = {};
      context.sharing = this.sharingUrls;
      context.print = this.options.printArticle;
      context.image = language.printImage;
      context.text = language.printText;
      context.print = language.print;
      Dust.render(sharing, context, (err, result) => {
        this.DOMContainer.innerHTML = result;
        this.attachClickHandlers();
        this.rendered = true;
        this.appState.triggerEvent(this.sharingEventName);
        if (context.print && !context.sharing) {
          this.appState.triggerEvent(CLICKED_PRINT_ALB);
        }
      });
    }
  }

  attachClickHandlers() {
    const shareItems = this.DOMContainer.querySelectorAll(".sharing-item");
    shareItems.forEach((item) => {
      const share = item.getAttribute("data-share");
      const id = item.getAttribute("data-id");
      let url = null;
      if (this.sharingUrls && id) {
        url = this.sharingUrls[parseInt(id, 10)];
      }
      item.addEventListener("click", () => {
        switch (share) {
          case "Facebook":
            this.appState.triggerEvent(CLICKED_FACEBOOK_SHARE);
            if (url) {
              window.open(url.url);
            }
            break;
          case "WhatsApp":
            this.appState.triggerEvent(CLICKED_WHATSAPP_SHARE);
            if (url) {
              window.open(url.url);
            }
            break;
          case "X":
            this.appState.triggerEvent(CLICKED_TWITTER_X_SHARE);
            if (url) {
              window.open(url.url);
            }
            break;
          case "Mail":
            this.appState.triggerEvent(CLICKED_MAIL_SHARE);
            if (url) {
              hideLoaderAndChangeLocation(url.url, window);
            }
            break;
          case "print":
            this.openPrint();
            break;
          case "print-image":
            this.printImage();
            break;
          case "print-text":
            this.printText();
            break;
          default:
        }
      });
    });
  }

  openPrint() {
    const printItems = this.DOMContainer.querySelector(".print-items");
    if (printItems) {
      printItems.classList.toggle("hidden");
      this.appState.triggerEvent(CLICKED_PRINT_ALB);
    }
  }

  printImage() {
    const { printing, container } = this.getPrintingElements("image");
    const buttons = document.querySelectorAll(
      `.swiper-slide-page-click-container .swiper-slide-page-click[data-contentid="${this.appState.contentid}"]`
    );

    container.classList.add("canvas-container");
    printing.innerHTML = "";
    printing.appendChild(container);

    if (buttons && buttons.length > 0) {
      const promises = this.processImages(
        Array.from(buttons),
        container,
        promises
      );
      if (promises.length > 0) {
        Promise.all(promises).then(() => {
          if (typeof window.print === "function") {
            window.print();
          }
        });
      }
      this.appState.triggerEvent(CLICKED_PRINT_IMAGE_ALB);
    }
  }

  printText() {
    const { printing, container } = this.getPrintingElements("text");
    const slide = document.querySelector(
      ".swiper-slide-active .alb-content-scroll"
    );

    container.classList.add("swiper-container-alb");
    container.innerHTML = slide.innerHTML;
    printing.innerHTML = "";
    printing.appendChild(container);

    if (typeof window.print === "function") {
      window.print();
    }

    this.appState.triggerEvent(CLICKED_PRINT_TEXT_ALB);
  }

  /**
   *
   * @returns {{container: HTMLDivElement, printing: Element}}
   */
  prepareImagePrint() {
    const printing = document.querySelector("#printing");
    const container = document.createElement("div");
    this.body.classList.remove("textPrinting");
    this.body.classList.add("imagePrinting");
    return { printing, container };
  }

  /**
   *
   * @returns {{container: HTMLDivElement, printing: Element}}
   */
  prepareTextPrint() {
    const printing = document.querySelector("#printing");
    const container = document.createElement("div");
    this.body.classList.remove("imagePrinting");
    this.body.classList.add("textPrinting");
    return { printing, container };
  }

  /**
   *
   * @param {"image" | "text"} type
   * @returns {{container: HTMLDivElement, printing: Element}}
   */
  getPrintingElements(type) {
    if (type === "image") {
      return this.prepareImagePrint();
    } else if (type === "text") {
      return this.prepareTextPrint();
    } else {
      throw new Error(`Invalid type: ${type}, must be "image" or "text"`);
    }
  }

  /**
   *
   * @param {number} pageId
   * @returns {string}
   */
  getSecurePrintingPreviewUrl(pageId) {
    const { userId, sessionId, downloadId } = this.appState;
    return generateSecurePreviewURL(
      this.options.printSize,
      pageId,
      sessionId,
      userId,
      downloadId
    );
  }

  /**
   *
   * @description Processes the images for printing
   * @param {Element[]} elements array of elements to process
   * @param {HTMLElement} container element to append the canvas elements to
   * @param {Promise[]} arr array of promises
   */
  processImages(elements, container) {
    return elements.reduce((promises, element) => {
      const pageId = parseInt(element.getAttribute("data-pageid"));
      const url = this.getSecurePrintingPreviewUrl(pageId);
      if (element instanceof HTMLElement) {
        promises.push(this.loadImage(element, container, url));
      }
      return promises;
    }, []);
  }

  /**
   * Loads an image into a canvas element and resizes it for printing
   * @param {HTMLElement} element
   * @param {HTMLElement} container
   * @param {string} url
   * @returns
   */
  loadImage(element, container, url) {
    return new Promise(async (resolve, reject) => {
      const top = parseFloat(element.style.top) / 100;
      const left = parseFloat(element.style.left) / 100;
      const width = parseFloat(element.style.width) / 100;
      const height = parseFloat(element.style.height) / 100;
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();
      // fetch the blob and create a URL since the new gateway requires specific headers to be passed
      const blobUrl = await fetchBlob(url).then((blob) =>
        URL.createObjectURL(blob)
      );
      img.src = blobUrl;
      container.appendChild(canvas);
      img.onload = () => {
        const margin = this.options.printExtraMargin;
        const marginLeft = this.options.printMarginLeft;
        const w = img.width;
        const h = img.height;
        const sx = w * left - marginLeft;
        const sy = h * top - marginLeft;
        const sw = w * width + margin * 2;
        const sh = h * height + margin * 2;
        canvas.width = sw;
        canvas.height = sh;
        const dw = sw;
        const dh = sh;
        ctx.drawImage(img, sx, sy, sw, sh, 0, 0, dw, dh);
        resolve();
      };
      img.onerror = () => {
        reject();
      };
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/components/sharingComponent.js